import { USER_LIST, USER_CREATE, USER_EDIT } from '../constants'

export default [
	{
		path: USER_LIST,
		name: 'users_list',
		component: () => import('@/views/users/list/listView.vue'),
		meta: {
			pageTitle: 'Listado de usuarios',
			permission: 'list_users',
			breadcrumb: [
				{
					text: 'Listado de usuarios',
					active: true,
				},
			],
		},
	},
	{
		path: USER_CREATE,
		name: 'users_create',
		component: () => import('@/views/users/form/formView.vue'),
		meta: {
			pageTitle: 'Crear Usuario',
			permission: 'list_users',
			breadcrumb: [
				{
					text: 'Listado de usuarios',
                    to: USER_LIST,
                },
				{
					text: 'Crear usuario',
					active: true,
				},
			],
		},
	},
	{
		path: `${USER_EDIT}/:id`,
		name: 'users_edit',
		component: () => import('@/views/users/form/formView.vue'),
		meta: {
			pageTitle: 'Editar Usuario',
			permission: 'list_users',
			breadcrumb: [
				{
					text: 'Listado de usuarios',
                    to: USER_LIST,
                },
				{
					text: 'Editar Usuario',
					active: true,
				},
			],
		},
	},
]
